// extracted by mini-css-extract-plugin
export default {"wrapper":"MainSelectors_wrapper__4LXrr","inner":"MainSelectors_inner__MLRZX","select":"MainSelectors_select__uZoiu"};